import { Link } from "react-router-dom";
import { ArrowRight, Download } from "lucide-react";
import ServiceLayout, { ContentSection } from "@/components/site/ServiceLayout";
import { Reveal, TickList } from "@/components/site/Reveal";
import { API } from "@/data/services";

const EMPLOYEES = [
  "Work stress and burnout",
  "Anxiety and low mood",
  "Grief and loss",
  "Relationship and family difficulties",
  "Trauma and critical incidents",
  "Managing change and workplace conflict",
];

const EMPLOYERS = [
  "A simple service agreement with no complex onboarding",
  "Blocks of sessions your team can draw on as needed",
  "Appointments at our Ashmore or Deakin rooms, or by telehealth nationwide",
  "Prompt response times so your people are seen quickly",
];

export default function Eap() {
  return (
    <ServiceLayout
      eyebrow="Services"
      title="Employee Assistance Program"
      lead="Confidential, employer-funded counselling and wellbeing support — short-term help with work stress, personal challenges and everything in between."
      image="https://images.unsplash.com/photo-1595104615356-cbe9c4364513?crop=entropy&cs=srgb&fm=jpg&q=85"
      imageAlt="Soft morning light across a quiet landscape"
    >
      <ContentSection eyebrow="For employees" title="Support with">
        <TickList items={EMPLOYEES} />
        <Reveal delay={0.1}>
          <div className="mt-10 max-w-3xl rounded-2xl border border-euca-line bg-white p-7 sm:p-8" data-testid="eap-confidentiality-note">
            <p className="text-base leading-relaxed text-charcoal/85">
              <span className="font-semibold">Your sessions are confidential.</span> What you discuss stays between
              you and your practitioner — your employer receives only de-identified, overall usage information,
              never the content of your sessions.
            </p>
            <p className="mt-3 text-base leading-relaxed text-mutedsoft">
              There is no cost to you — sessions are funded by your employer. Ask your HR contact whether Eucalypt
              Therapy is your EAP provider, or send us an enquiry.
            </p>
          </div>
        </Reveal>
      </ContentSection>

      <ContentSection eyebrow="For employers" title="A simple, genuine EAP for your team" pale>
        <TickList items={EMPLOYERS} />
        <Reveal delay={0.1}>
          <p className="mt-10 max-w-3xl text-base leading-relaxed text-mutedsoft">
            EAP arrangements are employer-funded under a straightforward agreement, with fees based on the number of
            sessions your organisation needs. Contact us to discuss an arrangement for your team.
          </p>
          <div className="mt-8 flex flex-wrap gap-4">
            <Link
              to="/contact?service=referral"
              data-testid="eap-employer-enquire-button"
              className="inline-flex items-center gap-2 rounded-full bg-euca px-7 py-3.5 text-sm font-semibold text-white transition-all duration-300 hover:bg-euca-dark"
            >
              Arrange EAP for your team <ArrowRight className="h-4 w-4" />
            </Link>
            <a
              href={`${API}/downloads/eap-employer-pack`}
              data-testid="eap-download-pack-button"
              className="inline-flex items-center gap-2 rounded-full border border-euca px-7 py-3.5 text-sm font-semibold text-euca transition-all duration-300 hover:bg-euca hover:text-white"
            >
              Download Employer Info Sheet <Download className="h-4 w-4" />
            </a>
          </div>
        </Reveal>
      </ContentSection>
    </ServiceLayout>
  );
}
